import { useMemo } from 'react';
import PropTypes from 'prop-types';

import IconError from 'src/assets/icons/Error';
import { IconInformation } from 'src/assets/icons/IconInformation';
import IconWarning from 'src/assets/icons/Warning';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';

import useStyles from './useStyles';

export const ICON_TYPE = {
  info: 'info',
  warning: 'warning',
  error: 'error',
};

const pickIconComponent = (icon) => {
  if (!icon) {
    return null;
  }

  if (icon === ICON_TYPE.warning) {
    return <IconWarning />;
  }
  if (icon === ICON_TYPE.error) {
    return <IconError />;
  }
  return <IconInformation style={{ color: '#F4F6FC' }} />;
};

const propTypes = {
  classes: PropTypes.shape({}),
  title: PropTypes.string,
  content: PropTypes.string,
  icon: PropTypes.oneOf(Object.values(ICON_TYPE)),
};

const defaultProps = {
  classes: null,
  title: null,
  content: null,
  icon: null,
};

const TooltipContent = ({ classes, title, content, icon }) => {
  const styles = useStyles({ classes });

  const iconComponent = useMemo(() => pickIconComponent(icon), [icon]);

  if (!title && !content) {
    return null;
  }

  return (
    <div className={styles.root}>
      {iconComponent && <div className={styles.icon}>{iconComponent}</div>}

      <div className={styles.texts}>
        {title && (
          <CustomTypography
            className={styles.title}
            variant={TYPOGRAPHY_VARIANT.medium12}
          >
            {title}
          </CustomTypography>
        )}
        <CustomTypography
          className={styles.content}
          variant={TYPOGRAPHY_VARIANT.regular12}
        >
          {content}
        </CustomTypography>
      </div>
    </div>
  );
};
TooltipContent.propTypes = propTypes;
TooltipContent.defaultProps = defaultProps;

export default TooltipContent;
